import { useState } from 'react'

import { F0Dialog } from '@factorialco/f0-react'

import i18n from 'modules/core/lib/i18n'

import { EmployeeSelectorV2 } from 'modules/employees/components/EmployeeSelectorV2'

interface Props {
  onInvite: (accessId: string) => void
  onClose: () => void
}

export const InviteUserModal = ({ onInvite, onClose }: Props) => {
  const [selectedAccessId, setSelectedAccessId] = useState<string | undefined>(undefined)

  return (
    <F0Dialog
      isOpen
      width="sm"
      title={i18n.t('cronofy.invite_user.title')}
      description={i18n.t('cronofy.invite_user.description')}
      onClose={onClose}
      primaryAction={{
        label: i18n.t('cronofy.invite_user.invite'),
        onClick: () => selectedAccessId && onInvite(selectedAccessId),
        disabled: !selectedAccessId
      }}
      secondaryAction={{
        label: i18n.t('cronofy.invite_user.cancel'),
        onClick: onClose,
        disabled: false
      }}
    >
      <EmployeeSelectorV2
        mandatory
        value={selectedAccessId}
        onChange={setSelectedAccessId}
        multiple={false}
        options={{
          hideLabel: true,
          asList: true
        }}
        useAccessId
      />
    </F0Dialog>
  )
}
